import { G_references } from "../../utils/globals/globals";
import { ENV_DEV } from "../../utils/window";
import run from "../animate/run";

/**
 * Run reference
 * @param {Boolean} enter
 * @param {String} name
 */
const runReference = (enter, name) => {
  const references = G_references.get(name);

  if (ENV_DEV && !references) {
    console.error(`[TorusKit error]: No reference named \`${name}\` found`);
    return;
  }

  for (const original of references) {
    const main = /** @type {MainClassProps} */ (original);

    const available = /** @type {Map<String, String>} */ (
      main.applied.get("reference")
    );

    run(
      main.events.get(`referenceenter:${available.get(name)}`),
      enter ? "enter" : "leave",
      true
    );
  }
};

export default runReference;
